import { cn } from '@/lib/cn'

export interface TableSkeletonProps {
  rows?: number
  cols?: number
  className?: string
}

/**
 * Animated skeleton placeholder for tables during loading.
 * Replaces full-page spinners in list/table loading states.
 */
export function TableSkeleton({
  rows = 5,
  cols = 4,
  className,
}: TableSkeletonProps): React.ReactElement {
  return (
    <div className={cn('kc-loader-in overflow-x-auto', className)} aria-busy="true" aria-label="Loading">
      <table className="min-w-full border-collapse text-sm">
        <thead>
          <tr className="border-b border-gray-200 dark:border-gray-700">
            {Array.from({ length: cols }).map((_, i) => (
              <th key={i} className="px-5 py-3.5">
                <div className="kc-bone h-3 w-20" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr
              key={rowIndex}
              className="border-b border-gray-100 last:border-b-0 dark:border-gray-700"
            >
              {Array.from({ length: cols }).map((_, colIndex) => (
                <td key={colIndex} className="px-5 py-3.5">
                  <div
                    className={cn(
                      'kc-bone h-3',
                      colIndex === 0 ? 'w-32' : colIndex === cols - 1 ? 'w-16' : 'w-24'
                    )}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

TableSkeleton.displayName = 'TableSkeleton'
